import { FormControlLabel, FormGroup } from "@mui/material";
import { ChangeEventHandler } from "react";
import Checkbox from "@mui/material/Checkbox";

type checkBoxProps = {
  label: string;
  checked:boolean;
  name:string;
  onChange: ChangeEventHandler<HTMLInputElement>;
};

const Checkboxcomponent = ({ label, checked= false,name, onChange }: checkBoxProps) => {
  return (
    <FormGroup>
      <FormControlLabel
        control={<Checkbox name={name} checked={checked} onChange={onChange} />}
        label={label}
      />
    </FormGroup>
  );
};

export default Checkboxcomponent;
